import Dropdown from "app/components/Dropdown";
import { CheckIcon, TicketsIcon } from "app/components/Icons";
import MemberProfile from "app/components/MemberProfile";
import { getTicketIcon } from "app/containers/Features/containers/Boards/containers/Home/containers/helpers";
import {
  ITicketTypes,
  TicketType,
} from "app/containers/Features/containers/Boards/types";
import React, { useEffect, useState } from "react";
import StatusSelectionButton from "./StatusSelectionButton";
import CommonTicketTypeSelection from "app/containers/Features/components/CommonTicketTypeSelection";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "app/containers/Features/containers/Boards/containers/Tickets/redux/slice";
import { selectTicketTypes } from "app/redux/selector";

interface TicketTypeDropdownProps {
  value?: string;
  setValue?: (value: string) => void;
}

const TicketTypeDropdown: React.FC<TicketTypeDropdownProps> = ({
  setValue,
  value,
}) => {
  const data = useSelector(selectTicketTypes);
  const [selectedData, setSelectedData] = useState<ITicketTypes | null>(null);

  const handleSelect = (data: ITicketTypes) => {
    if (setValue) {
      setValue(data._id);
    }
    setSelectedData(data);
  };

  useEffect(() => {
    if (value) {
      const nData = data
        .filter((x) => x._id === value)
        .map((ele) => {
          return ele;
        });
      setSelectedData(nData[0]);
    }
    return () => {};
  }, [value]);

  useEffect(() => {
    if (value) {
      const selected = data.find((x) => x._id === value);
      setSelectedData(selected as ITicketTypes);
    }
    return () => {};
  }, [value]);

  return (
    <>
      <CommonTicketTypeSelection
        trigger={
          <button className="flex items-center justify-between w-full px-2 py-2 rounded-md hover:bg-[#F4F5F7] rounded-[4px] data-[state=open]:border-[#79808A] data-[state=open]:outline-[#79808A] data-[state=open]:border-[1px] border-[#79808A]">
            <StatusSelectionButton
              label="Ticket type:"
              icon={<TicketsIcon size={18} color="#79808A" />}
              className="text-[12px] leading-[18px] font-medium text-secondary mt-[2px]"
              selectedIcon={selectedData &&
                <img
                  src={getTicketIcon(selectedData?.icon as TicketType)}
                  alt="task-icon"
                  className="size-[24px]"
                />
              }
              selectedLabel={selectedData?.name}
            />
          </button>
        }
        align="end"
        dropDownClassName="min-w-[250px]"
        value={value}
        showEndIcon
        setValue={handleSelect}
      />
    </>
  );
};

export default TicketTypeDropdown;
